import React from 'react'
import { Box, Stack, Typography } from '@mui/material';

const ViewTab = ({ active, icon: Icon, label, count, onClick }) => {
  return (
        <Stack
            direction="row"
            spacing={0.75}
            alignItems="center"
            onClick={onClick}
            sx={{
                cursor: "pointer",
                px: 2,
                py: 1,
                borderRadius: 1.75,
                bgcolor: active ? "#003C59" : "transparent",
                color: active ? "#fff" : "text.secondary",
                transition: "background-color .15s ease",
                "&:hover": { bgcolor: active ? "#003C59" : "rgba(0,0,0,0.04)" },
            }}
        >
            <Icon sx={{ fontSize: 18 }} />
            <Typography variant="body2" sx={{ fontWeight: 600 }}>
                {label}
            </Typography>
            {count != null && (
                <Box
                    sx={{
                        bgcolor: active ? "#00C9DB" : "rgba(0,0,0,0.08)",
                        color: active ? "#fff" : "text.secondary",
                        fontSize: 12,
                        fontWeight: 700,
                        borderRadius: "999px",
                        minWidth: 20,
                        height: 20,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        px: 0.75,
                    }}
                >
                    {count}
                </Box>
            )}
        </Stack>
    );
}

export default ViewTab